import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Acceuil from "./components/Accueil";
import Project from "./components/Project"
import Fondateur from "./components/Fondateur";
import Contact from "./components/Contact";

function App() {
  return (
    <>
      <Navbar />
      <Acceuil />
      <Project/>
      <Fondateur />
      <Contact />
    </>
  );
}

export default App;
